<template>
  <div>
    <the-header />
    <section id="page-content">
      <div class="container-fluid">
        <header class="header-page">
          <h1>{{ siteName }}</h1>
          <h2 class="text-muted">Receipt for Order</h2>
          <div class="step-progress-bar">
            <div class="step-progress" style="width:100%;"></div>
          </div>
        </header>
        <span
          v-if="
            orderStatus == 'pendingPayment' ||
              orderStatus == 'pendingRecGovUpdate'
          "
        >
          <font-awesome-icon icon="spinner" class="fa fa-fw fa-pulse fa-2x" />
          One Moment...
        </span>
        <receipt-order-complete
          v-if="orderStatus === 'complete'"
          :downloadUrl="downloadUrl"
          :agencyName="agencyName"
        />
        <receipt-payment-complete
          v-if="orderStatus === 'unableToObtainSuccessfulStatus'"
        />
      </div>
    </section>
    <the-footer />
  </div>
</template>

<script>
import TheHeader from "@/components/Shared/TheHeader.vue";
import TheFooter from "@/components/Shared/TheFooter.vue";
import ReceiptPaymentComplete from "@/components/Receipt/ReceiptPaymentComplete.vue";
import ReceiptOrderComplete from "@/components/Receipt/ReceiptOrderComplete.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faSpinner);

export default {
  name: "Receipt",
  components: {
    TheHeader,
    TheFooter,
    ReceiptPaymentComplete,
    ReceiptOrderComplete,
    FontAwesomeIcon
  },
  computed: {
    siteName() {
      return this.$store.getters["cart/siteName"];
    },
    orderStatus() {
      return this.$store.getters["cart/status"];
    },
    orderDetails() {
      return this.$store.getters["cart/orderDetails"];
    },
    downloadUrl() {
      let passes = this.$store.getters["cart/passes"];
      if (passes.length === 1) {
        return passes[0].passUrl;
      }
      return "";
    },
    agencyName() {
      return this.$store.getters["cart/agencyName"];
    }
  },
  methods: {
    home() {
      this.$router.go("home");
    }
  },
  created() {
    if (this.orderStatus != "complete") {
      this.$store.dispatch("cart/returnFromPurchase");
    }
  }
};
</script>
